export default "__VITE_ASSET__6186fa46__"